<template>
    <div class="inputName " @click="handleClick">
        <div class="name" v-show="!isEdit">{{ templateName }}</div>
        <input type="text" v-show="isEdit" v-model="templateName" @focus="isEdit = true" ref="inputRef"
            @blur="inputBlur" @keydown.enter.stop.prevent="onEnter" />
        <el-icon :size="20" @click="inputBlur">
            <Edit />
        </el-icon>
    </div>
</template>
<script lang="ts" setup>
import { ref, nextTick, computed } from 'vue'
import { Edit } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import { useMiscStore } from '@/stores/misc'
import { useSdkStore } from "@/stores/sdk";
const miscStore = useMiscStore()
const templateName = computed({
    get: () => miscStore.getTemplateName(),
    set: (val: string) => miscStore.setTemplateName(val)
})
const isEdit = ref(false)
const inputRef = ref<HTMLInputElement | null>(null)

const handleClick = () => {
    isEdit.value = true
    nextTick(() => {
        inputRef.value?.focus()
    })
}
const inputBlur = () => {
    isEdit.value = false
}
const onEnter = () => {
    saveTemplateName()
    // console.log('qweqweqweqwe')
}
const saveTemplateName = () => {
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    sdk.designOpt?.saveTemplate()
    // saveTemplate()
}
</script>
<style scoped>
.inputName {
    display: flex;
    height: 40px;
    width: 140px;
    padding: 0 15px;
    align-items: center;
    gap: 8px;
    margin-right: 10px;
}

input {
    width: 100px;
    height: 100%;
    font-size: 14px;
    font-weight: 700;
    color: #2a2a2a;
    border: none;
    background: transparent;
}

input:focus {
    outline: none;
}

.name {
    font-size: 14px;
    font-weight: 700;
    color: #2a2a2a;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
